'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _startCase2 = require('lodash/startCase');

var _startCase3 = _interopRequireDefault(_startCase2);

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _cloneDeep2 = require('lodash/cloneDeep');

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Modal = require('react-bootstrap/lib/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _ButtonToolbar = require('react-bootstrap/lib/ButtonToolbar');

var _ButtonToolbar2 = _interopRequireDefault(_ButtonToolbar);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Columns = require('./Columns');

var _ConfigurableReportsCheckboxGroup = require('./ConfigurableReportsCheckboxGroup');

var _ConfigurableReportsCheckboxGroup2 = _interopRequireDefault(_ConfigurableReportsCheckboxGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var FORM_REF = 'FORM';

var ConfigurableReportsSideModal = (_dec = (0, _mobxReact.inject)('UiStore', 'FunderStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(ConfigurableReportsSideModal, _Component);

  function ConfigurableReportsSideModal(props) {
    _classCallCheck(this, ConfigurableReportsSideModal);

    var _this = _possibleConstructorReturn(this, (ConfigurableReportsSideModal.__proto__ || Object.getPrototypeOf(ConfigurableReportsSideModal)).call(this, props));

    _initDefineProp(_this, 'fields', _descriptor, _this);

    _initDefineProp(_this, 'submittableConfiguration', _descriptor2, _this);

    _this.setFields(props.tableType);
    _this.submittableConfiguration = props.configuredFields;
    return _this;
  }

  _createClass(ConfigurableReportsSideModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setFields(nextProps.tableType);
    }
  }, {
    key: 'onFormInputChange',
    value: function onFormInputChange(e) {
      var _e$target = e.target,
          id = _e$target.id,
          checked = _e$target.checked;

      if (checked && !this.submittableConfiguration.includes(id)) {
        this.submittableConfiguration.push(id);
      } else if (!checked) {
        this.submittableConfiguration = this.submittableConfiguration.filter(function (field) {
          return field !== id;
        });
      }
    }
  }, {
    key: 'onFormSubmit',
    value: function onFormSubmit(e) {
      var _props$UiStore = this.props.UiStore,
          reportPage = _props$UiStore.reportPage,
          ConfigurableReports = _props$UiStore.modals.ConfigurableReports;

      e.preventDefault();

      reportPage.fields = this.submittableConfiguration;
      this.props.changeFilters();
      ConfigurableReports.close();
    }
  }, {
    key: 'deselectAll',
    value: function deselectAll(e) {
      var _this2 = this;

      var newFields = {};
      Object.keys(this.fields).forEach(function (title) {
        newFields[title] = _this2.fields[title].map(function (field) {
          return _extends({}, field, {
            checked: false
          });
        });
      });

      this.fields = newFields;
      Object.keys(this.fields).forEach(function (title) {
        var fields = _this2.fields[title].map(function (field) {
          return field.fieldName;
        });
        _this2.clearSection(fields);
      });
    }
  }, {
    key: 'setFields',
    value: function setFields(tableType) {
      var _this3 = this;

      var _props = this.props,
          accessibleFields = _props.accessibleFields,
          configuredFields = _props.configuredFields,
          customFields = _props.customFields,
          isFinanceCustomer = _props.FunderStore.isFinanceCustomer,
          columns = (0, _cloneDeep3.default)(_Columns.REPORT_COLUMNS[tableType]),
          filteredColumns = isFinanceCustomer ? columns : this.filterOutFinanceFields(columns);


      filteredColumns.forEach(function (column) {
        var name = column.Header;
        if (name) {
          _this3.fields[name] = [];
          column.columns.forEach(function (subCol) {
            accessibleFields.includes(subCol.accessor) && _this3.fields[name].push({
              checked: configuredFields.includes(subCol.accessor),
              fieldName: subCol.accessor,
              name: subCol.Header
            });
          });
        }
      });

      if (!(0, _isEmpty3.default)(customFields)) {
        this.fields['Custom Fields'] = customFields.map(function (field) {
          return {
            checked: configuredFields.includes(field),
            fieldName: field,
            name: (0, _startCase3.default)(field)
          };
        });
      }
    }
  }, {
    key: 'clearSection',
    value: function clearSection(fields) {
      this.submittableConfiguration = this.submittableConfiguration.filter(function (field) {
        return !fields.includes(field);
      });
    }
  }, {
    key: 'fillSection',
    value: function fillSection(fields) {
      this.submittableConfiguration = this.submittableConfiguration.concat(fields);
    }
  }, {
    key: 'filterOutFinanceFields',
    value: function filterOutFinanceFields(reportColumns) {
      return reportColumns.map(function (columnGroup) {
        return _extends({}, columnGroup, { columns: columnGroup.columns.filter(function (column) {
            return !column.isFinanceColumn;
          }) });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var onClose = this.props.onClose;


      return _react2.default.createElement(
        _Modal2.default,
        {
          show: true,
          onHide: onClose,
          className: 'modal-configurable-reports right side-modal' },
        _react2.default.createElement(
          _Modal2.default.Header,
          { closeButton: true },
          _react2.default.createElement(
            _Modal2.default.Title,
            null,
            'Report Configuration'
          )
        ),
        _react2.default.createElement(
          _Modal2.default.Body,
          null,
          _react2.default.createElement(
            'form',
            {
              ref: FORM_REF,
              onChange: this.onFormInputChange,
              onSubmit: this.onFormSubmit
            },
            _react2.default.createElement(
              'h3',
              null,
              'Data columns'
            ),
            _react2.default.createElement(
              'div',
              { style: { display: 'flex', justifyContent: 'left' } },
              _react2.default.createElement(
                _Button2.default,
                { onClick: this.deselectAll, bsStyle: 'link' },
                'Deselect All'
              )
            ),
            Object.keys(this.fields).map(function (title) {
              return _react2.default.createElement(
                'div',
                { key: title, className: 'clearfix' },
                _react2.default.createElement(_ConfigurableReportsCheckboxGroup2.default, {
                  clearSection: _this4.clearSection,
                  fieldSets: _this4.fields,
                  fillSection: _this4.fillSection,
                  title: title
                })
              );
            })
          )
        ),
        _react2.default.createElement(
          _Modal2.default.Footer,
          null,
          _react2.default.createElement(
            _ButtonToolbar2.default,
            { className: 'pull-right' },
            _react2.default.createElement(
              _Button2.default,
              { onClick: onClose },
              'Cancel'
            ),
            _react2.default.createElement(
              _Button2.default,
              { bsStyle: 'primary', type: 'submit', onClick: this.onFormSubmit },
              'Save'
            )
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return ConfigurableReportsSideModal;
}(_react.Component), _class3.propTypes = {
  accessibleFields: _propTypes2.default.array.isRequired,
  changeFilters: _propTypes2.default.func.isRequired,
  configuredFields: _propTypes2.default.array.isRequired,
  customFields: _propTypes2.default.array.isRequired,
  FunderStore: _propTypes2.default.object.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  tableType: _propTypes2.default.string.isRequired,
  UiStore: _propTypes2.default.object.isRequired
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'fields', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'submittableConfiguration', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
})), _class2)) || _class) || _class) || _class);
var _default = ConfigurableReportsSideModal;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(FORM_REF, 'FORM_REF', '/app/src/components/page-reports/ConfigurableReportsSideModal.js');
  reactHotLoader.register(ConfigurableReportsSideModal, 'ConfigurableReportsSideModal', '/app/src/components/page-reports/ConfigurableReportsSideModal.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-reports/ConfigurableReportsSideModal.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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